import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function PastAppointmentView({}) {
  const [pastAppointment, setPastAppointment] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const attendeeId = JSON.parse(localStorage.getItem("pid"));
  const [t] = useTranslation();

  //fetch past appointment
  const URL = `/api/v1/appointments/past?attendeeId=${attendeeId}`;
  useEffect(() => {
    const pastData = async () => {
      setIsFetchingData(true);
      const token = "Bearer " + localStorage.getItem("token");
      try {
        const response = await fetch(URL, {
          method: "GET",
          headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
            Authorization: token.replace(/['"]+/g, ""),
          },
          credentials: "include",
        });
        const data = await response.json();
        // console.log(data.appointments);
        setPastAppointment(data.appointments);
        if (!response.status === 200) {
          const error = new Error(response.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
      setIsFetchingData(false);
    };
    pastData();
  }, [URL]);

  //fetch completed appointment
  const completeURL = `/api/v1/appointments/:id/complete`;

  const completeAppt = async () => {
    const token = "Bearer " + localStorage.getItem("token");
    try {
      const response = await fetch(completeURL, {
        method: "PUT",
        headers: {
          Accept: "application/json; charset=utf-8",
          "Content-Type": "application/json",
          Authorization: token.replace(/['"]+/g, ""),
        },
        credentials: "include",
      });
      const data = await response.json();
      console.log(data.appointment);

      if (!response.status === 200) {
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };

  // const selectedUpcomingList =  moment(new Date(cValue.date)).format('DD MMMM, dddd, YYYY');
  return isFetchingData ? (
    <div
      style={{
        margin: "auto",
        display: "flex",
        justifyContent: "center",
      }}
      id="loader"
    ></div>
  ) : (
    <>
      {pastAppointment.map((cValue) => {
        return (
          <div className="box_view_app" key={cValue.id}>
            <div className="head_view d-flex justify-content-between align-items-center">
              <span className="txt_normal">{cValue?.ownerMetadata?.name}</span>
              <span className="txt_small">
                {cValue?.ownerMetadata?.code.slice(0, 2) == "DR"
                  ? t("appointment.DOCTOR.doctor1")
                  : t("appointment.DOCTOR.doctor2")}
              </span>
            </div>
            <span className="txt_normal">{cValue.startTime}</span>
            <span className="txt_normal">
              {moment(new Date(cValue.date)).format("DD MMMM, dddd, YYYY")}
            </span>
            <span className="txt_normal">
              {cValue?.online ? "Online" : cValue?.spaceMetadata?.name}
            </span>
            <div className="blueText">
              {cValue ? cValue.appointmentStatus : ""}
            </div>
          </div>
        );
      })}
    </>
  );
}

export default PastAppointmentView;
